module.exports = __webpack_public_path__ + "img/fear-cover.c58f9ea9.jpg";